module.exports = __webpack_public_path__ + "img/nr.b3898a09.svg";